mutation ModifySentenceRecording($sentenceRecording: ID!, $pronunciation: ID!, $torahMelodyStyle: ID, $haftarahMelodyStyle: ID, $sentenceGroupMelodyStyle: ID, $tags: [ID!]!) {
  modifySentenceRecording(sentenceRecording: $sentenceRecording, pronunciation: $pronunciation, torahMelodyStyle: $torahMelodyStyle, haftarahMelodyStyle: $haftarahMelodyStyle, sentenceGroupMelodyStyle: $sentenceGroupMelodyStyle, tags: $tags) {
    ok
    errors
  }
}
